import BaseRequest from './BaseRequest';

export default class Penalties extends BaseRequest {
    /**
     * Penalties constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(
        requestMode = 'provider',
        providerId = '',
        customerId = '',
        auth = true,
        fowardRequest = true,
    ) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('Penalties');
        this.setEndpoint('membership_penalty_systems');
    }
}
